export type RobotsPreset = "allow-all" | "disallow-all" | "custom";

export function generateRobotsTxt(preset: RobotsPreset, paths: string[] = []) {
  if (preset === "allow-all") {
    return "User-agent: *\nAllow: /\n";
  }

  if (preset === "disallow-all") {
    return "User-agent: *\nDisallow: /\n";
  }

  const normalizedPaths = paths
    .map((path) => path.trim())
    .filter(Boolean)
    .map((path) => (path.startsWith("/") ? path : `/${path}`));

  return [
    "User-agent: *",
    "Allow: /",
    ...normalizedPaths.map((path) => `Disallow: ${path}`),
    "",
  ].join("\n");
}
